import { render, staticRenderFns } from "./itinfo.vue?vue&type=template&id=17db4264&scoped=true&"
import script from "./itinfo.vue?vue&type=script&lang=js&"
export * from "./itinfo.vue?vue&type=script&lang=js&"
import style0 from "./itinfo.vue?vue&type=style&index=0&id=17db4264&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17db4264",
  null
  
)

export default component.exports